var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SnapSet = function() {
    this._content = new lib_core.Collections.HashSet();
    this.filter = null; // function that can filter on snap elements to tweak snap behaviour
};

module.exports = SnapSet;

SnapSet.prototype.add = function(obj, priority, range, orig, parent, polarity, key, filter){
    var self = this;
    var container = {};
    container.obj = obj;
    container.priority = priority;

    container.range = range || 0; // range of extra influence
    container.polarity = polarity || 0; // polarity: -1 = negative, 0 = neutral, +1 = positive: only opposit polarities will snap together, neutral snaps to every polarity
    container.key = key;
    container.filter = filter || this.filter; // filter needs to be passed to all containers because these can easily swap snapSets

    if (orig) {
        container.orig = orig;
    } else {
        container.orig = [obj];
    }

    // console.assert(parent, "SnapSet: parent is not defined!");
    container.parent = parent;

    self._content.add(container);
};

SnapSet.prototype.addHor = function(point, priority, range, orig, parent, polarity, key, filter){
    var self = this;
    self.add(new lib_geometry.Line(lib_geometry.Line.HOR,point), priority, range, orig, parent, polarity, key, filter);
};

SnapSet.prototype.addVer = function(point, priority, range, orig, parent, polarity, key, filter){
    var self = this;
    self.add(new lib_geometry.Line(lib_geometry.Line.VER,point), priority, range, orig, parent, polarity, key, filter);
};

SnapSet.prototype.addAll = function(snapset){
    var self = this;
    self._content.addAll(snapset._content);
};

SnapSet.prototype.move = function (vec){
    var self = this;
    self._content.forEach(function(container){
        container.obj = container.obj.translate(vec);
    });
};

SnapSet.prototype.setFilter = function (f) {
    this.filter = f;
    this._content.forEach(function(container){
        container.filter = f;
    });
};

SnapSet.prototype.trySnapTo = function(snapdist, snapModel, editorModel) {
    var self = this;
    var options = [];

    var mousePos = editorModel.mousePos();

    var workplane = editorModel.cameraModel().workplane();

    var elementInWorkplaneFilter = function (el) {
        if(el.obj instanceof lib_geometry.Line && el.parent && el.parent.data &&
            el.parent.data.boundingBox && el.parent.data.boundingBox()) {
            var bb = el.parent.data.boundingBox();
            return workplane.contains(bb) || workplane.intersects(bb);
        } else {
            return workplane.contains(el.obj) || workplane.intersects(el.obj);
        }
    };

    // only snap from objects that are in the workplane
    var fromList = this._content.toArray();
    fromList = fromList.filter(elementInWorkplaneFilter);

    fromList.forEach(function(from){
        var candidates = snapModel.toSpatialIndex.query(from.obj.getBB().buffer(snapdist));
        // only snap to objects that are in the workplane
        candidates = candidates.filter(elementInWorkplaneFilter);
        for(var i=0; i < candidates.length; i++) {
            var to = candidates[i];
            if(from.parent && to.parent && from.parent === to.parent) continue;
            if((from.obj instanceof lib_geometry.Line || from.obj instanceof lib_geometry.Segment) &&
               (to.obj instanceof lib_geometry.Line || to.obj instanceof lib_geometry.Segment)) {
                if(!from.obj.parallel(to.obj)) continue;
            }
            var distVec = from.obj.distanceVec(to.obj);
            if (distVec !== null && distVec !== undefined) {
                var dist = distVec.length() - from.range/2 - to.range/2;
                if (dist < snapdist) {
                    var opt = {};
                    opt.to = to;
                    opt.from = from;
                    opt.dist = dist;
                    opt.priority = to.priority + from.priority;
                    opt.pullSnap = (to.polarity * from.polarity <= 0); // polarity multiplication is negative or zero value = snap together, positive value = pull apart
                    opt.vec = opt.pullSnap ? distVec : distVec.mult(1 - (from.range/2 + to.range/2 + snapdist)/distVec.length() );

                    if (!opt.pullSnap) continue;
                    if (from.filter && !from.filter(to)) continue;
                    options.push(opt);
                }
            }
        }
    });

    options = options.filter(function (opt) {
        var rule = snapModel.getRule(opt.from, opt.to);
        if (!rule || rule(opt.from, opt.to))
            return true;
        return false;
    });

    options.sort(function(a,b){
        if ((b.priority - a.priority) === 0) {
            if (b.pullSnap == a.pullSnap){
                if(mousePos && (a.dist - b.dist) === 0) {
                    return a.to.obj.distance(mousePos) - b.to.obj.distance(mousePos);
                } else {
                    return a.dist - b.dist;
                }
            } else {
                return (b.pullSnap) ? -1 : 1; // give lower priority to snap points pulling together, higher priority to pushing apart
            }
        } else {
            return b.priority - a.priority;
        }
    });

    // Look for potential intersection points
    if (options.length > 1 && (options[0].to.obj instanceof lib_geometry.Line || options[0].to.obj instanceof lib_geometry.Segment)) {
        var i;
        for(i = 1; i < options.length; i++) {
            // Jump out after evaluating 30 candidates
            // if (i > 30) return options[0]; // TODO: is this still needed?

            var succes = false;
            switch (options[i].to.obj.constructor) {
                case lib_geometry.Line:
                    succes = !options[0].to.obj.parallel(options[i].to.obj);
                    break;
                case lib_geometry.Segment:
                    succes = options[0].to.obj.intersects(options[i].to.obj);
                    break;
                default:
                    succes = false;
            };
            if(succes) break;
        }

        if (i == options.length) return options[0];

        var inter = options[0].to.obj.intersection(options[i].to.obj);

        if (!inter) return options[0];

        var opt = {};
        opt.to = {};
        opt.to.obj = inter;
        opt.to.orig = [options[0].to.obj, options[i].to.obj];

        // If origin are point and line (like center and pin), look at projection to snap
        if (options[0].from.obj.constructor == lib_geometry.Line && options[i].from.obj.constructor == lib_geometry.Coord) {
            opt.from = {};
            opt.from.obj = options[0].from.obj.closestPointToPoint(options[i].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[0].from.obj.constructor == lib_geometry.Segment && options[i].from.obj.constructor == lib_geometry.Coord) {
            opt.from = {};
            opt.from.obj = options[0].from.obj.closestPointToPoint(options[i].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[i].from.obj.constructor == lib_geometry.Line && options[0].from.obj.constructor == lib_geometry.Coord) {
            opt.from = {};
            opt.from.obj = options[i].from.obj.closestPointToPoint(options[0].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[i].from.obj.constructor == lib_geometry.Segment && options[0].from.obj.constructor == lib_geometry.Coord) {
            opt.from = {};
            opt.from.obj = options[i].from.obj.closestPointToPoint(options[0].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[i].from.obj.constructor == lib_geometry.Line && options[0].from.obj.constructor == lib_geometry.Line) {
            opt.from = {};
            opt.from.obj = options[i].from.obj.intersection(options[0].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[i].from.obj.constructor == lib_geometry.Line && options[0].from.obj.constructor == lib_geometry.Segment) {
            opt.from = {};
            opt.from.obj = options[i].from.obj.intersection(options[0].from.obj.line());
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else if (options[i].from.obj.constructor == lib_geometry.Segment && options[0].from.obj.constructor == lib_geometry.Line) {
            opt.from = {};
            opt.from.obj = options[i].from.obj.line().intersection(options[0].from.obj);
            opt.from.orig = [options[0].to.obj, options[i].to.obj];
        } else {
            opt.from = options[0].from;
        }
        if(opt.from.obj) {
            opt.vec = opt.from.obj.distanceVec(inter);
            opt.dist = opt.vec.length();
        } else {
            return options[0];
        }

        // Don't return a point that is further away than the snap distance
        if (opt.dist > snapdist) {
            return options[0];
        }

        return opt;
    } else {
        return options[0];
    }
};

